<template>
	<div v-if="title || subtitle || content" class="row">
		<div :class="!content.length ? 'column12 align-center' : 'column6 '">
			<h2 v-if="subtitle" class="subtitle" :class="content.length && 'no-after align-left'">
				{{ subtitle }}
			</h2>
		</div>
		<div class="fullwidth-row flex">
			<div :class="!content.length ? 'column12 align-center' : 'column6'">
				<div class="title-reverse-wrapper">
					<h2 v-if="title" class="title">{{ title }}</h2>
				</div>
			</div>
			<div v-if="content" class="columns column5">
				<div v-parse-links class="content" v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.align-center {
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.title,
.subtitle,
.content {
	text-align: left;
	justify-content: left;
}

@media (max-width: 920px) {
	.columns {
		flex: 1 0 100%;
		max-width: 100%;
	}

	.fullwidth-row {
		flex-wrap: wrap;
	}

	.title {
		text-align: center !important;
	}
}
</style>
